import React from 'react';
import { connect } from 'react-redux';
import { firstError } from '@/utils/errors';
import { readStates, states } from '@/constants/lifecycle';
import { newRequestUrl } from '@/constants/urls';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import { requestSourceEntities } from '../constants';
import { resolveRequestWorkflow } from '../state/state';

const DuplicateRequestAction = ({
  code,
  newRequestCode,
  readErrors,
  readStatus,
}) => (
  <RibbonMenu
    name="duplicate"
    icon="clone"
    message="actions.duplicate"
    url={newRequestUrl(requestSourceEntities.REQUEST, code, newRequestCode, '#')}
    className="aridhia-duplicate-request-action"
    disabled={readStatus !== states.SUCCESS || firstError(readErrors) !== null}
  />
);

const mapStateToProps = ({
  requests: { requests, newRequestCode },
  workflows: { workflows },
}, ownProps) => {
  const { request } = resolveRequestWorkflow(requests, workflows, ownProps, readStates);

  return {
    newRequestCode,
    readErrors: request.readErrors,
    readStatus: request.readStatus,
  };
};

export default connect(mapStateToProps)(DuplicateRequestAction);
